
import React from 'react';
import { Modal2 } from "../modal";

const on_close = component => () => {
  component.setState({
    error: false,
    error_msg: "",
  })
}

const ErrorDialog = props => {
  const component = props.component;

  const msg = component.state.error_msg;

  const button_list = [
    { id: "ok", label: "Ok", cb: on_close(component) }
  ]

  const header = (
    <div align={"left"}>
      <span>Error</span>
    </div>
  );


  return (
    <Modal2
      header={header}
      buttonList={button_list}>
      <div>
        { msg }
      </div>
    </Modal2>

  )
}

export { ErrorDialog };
